import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api/types";

const GetSubmissionProcess: ApiQueryConfig<
  ApiResponse<any>,
  { societyId: string; submissionProcessId: string },
  Record<string, unknown>
> = {
  apiPath:
    "/api/v1/society/{societyId}/submission/process/{submissionProcessId}",
  queryKey: {
    baseQueryKey: ["GetSubmissionProcess"],
    dynamicQueryKey: ["submissionProcessId"],
  },
};

export { GetSubmissionProcess };
